import { en } from "./en";
import { zh } from "./zh";

const messages = {
  en,
  zh,
};
export default messages;
